import { fields, form, zodValidator } from "@codeleap/form"
import { t } from "@lingui/core/macro"
import { z } from "zod"

import '../i18n'

export const reportUser = form('reportUser', {
  description: fields.text({
    label: t`Describe your issue`,
    validate: zodValidator(
      z.string()
        .max(250)
        .refine(
          (val) => val.replace(/\s/g, '').length >= 15,
          { message: 'Description must have at least 15 characters (excluding spaces)' }
        )
    ),
    placeholder: t`Add description`,
    multiline: true,
  }),
  file: fields.file(),
})